import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-none d-sm-flex" }
const _hoisted_2 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_app = _resolveComponent("v-app")!
  const _component_vue_particles = _resolveComponent("vue-particles")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, {
      id: "app",
      theme: _ctx.theme
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar, { elevation: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("dev.pppig236.com", -1)
              ])),
              _: 1,
              __: [0]
            }),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_btn, {
                class: "mr-3",
                to: "/"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Home", -1)
                ])),
                _: 1,
                __: [1]
              }),
              _createVNode(_component_v_btn, {
                class: "mr-3",
                href: "/blog"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Blog", -1)
                ])),
                _: 1,
                __: [2]
              }),
              _createVNode(_component_v_btn, {
                class: "mr-3",
                to: "/repos"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Repositories", -1)
                ])),
                _: 1,
                __: [3]
              })
            ]),
            _createVNode(_component_v_btn, {
              icon: "",
              onClick: _ctx.toggleTheme
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("mdi mdi-brightness-6", -1)
                  ])),
                  _: 1,
                  __: [4]
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_v_bottom_navigation, { class: "d-flex d-sm-none" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("mdi mdi-home", -1)
                  ])),
                  _: 1,
                  __: [5]
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Home", -1))
              ]),
              _: 1,
              __: [6]
            }),
            _createVNode(_component_v_btn, { href: "/blog" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("mdi mdi-post", -1)
                  ])),
                  _: 1,
                  __: [7]
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Blog", -1))
              ]),
              _: 1,
              __: [8]
            }),
            _createVNode(_component_v_btn, { to: "/repos" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("mdi mdi-github", -1)
                  ])),
                  _: 1,
                  __: [9]
                }),
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Repos", -1))
              ]),
              _: 1,
              __: [10]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["theme"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vue_particles, {
        id: "tsparticles",
        options: {
      preset: 'snow',
      background: {
        color: {
          value: '#0d47a1'
        }
      }
    }
      })
    ])
  ], 64))
}